<template>
	<div class="binding-body">
		<div class="search-box">
			<div class="input-box">
				<span>店铺名称：</span>
				<el-input
					v-model="name"
					placeholder="请输入店铺名称"
					class="name-input"
					size="small"
					></el-input>
			</div>
			<div class="input-box-btn">
				<el-button
					type="primary"
					class="search-btn"
					size="small"
					plain
					@click="tableReload">查询</el-button>
			</div>
			<div class="input-box-btn">
				<el-button
					class="search-btn"
					size="small"
					plain
					@click="clear">清空</el-button>
			</div>
		</div>
		<div class="table-wrap">
			<div class="table-box">
				<el-table
					ref="table"
					class="grid-content"
					:data="showTableData"
					:height="tableHeight"
					border>
					<el-table-column
					align="center"
					label="选择"
					width="55">
						<template slot-scope="scope">
							<el-checkbox v-model="scope.row.checkFlag" :key="scope.row.id" @change="selectChange(scope.row)"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column
						label-class-name = "column-index"
						label="序号"
						type="index"
						width="70"
						align="center">
					</el-table-column>
					<el-table-column
						prop="name"
						label="店铺名称"
						align="center"
						min-width="150">
					</el-table-column>
				</el-table>
			</div>
			<div class="table-box">
				<el-table
					class="grid-content"
					:data="checkArr"
					:height="tableHeight"
					border>
					<el-table-column
					align="center"
					label="选择"
					width="55">
						<template slot-scope="scope">
							<el-checkbox v-model="scope.row.checkFlag" @change="selectedChange(scope.row)" ></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column
						label-class-name = "column-index"
						label="序号"
						type="index"
						width="70"
						align="center">
					</el-table-column>
					<el-table-column
						prop="name"
						label="店铺名称"
						align="center"
						min-width="150">
					</el-table-column>
				</el-table>
			</div>
		</div>
         <div class="binding-foot">
            <el-button class="btn" plain type="primary" @click="cancelClick">取消</el-button>
            <el-button class="btn" plain type="primary" @click="saveClick">保 存</el-button>
        </div>
	</div>
</template>
<script>
export default {
	name: 'binding',
	props: {
		isShow: Boolean,
		selectedShopList: {
			type: Array,
			default: () => []
		}
	},
	data () {
		return {
			showTableData: [],
			roleId: '',
			name: '',
			tableData: [],
			checkArr: [],
			tableHeight: '100%',
			firstFlag: false
		}
	},
	watch: {
		isShow: {
			handler (val) {
				if (val === true) {
					this.name = ''
					this.firstFlag = true
					this.checkArr = this.$fxUtils.deepClone(this.selectedShopList)
					this.tableReload()
				} else {
					this.tableData = []
					this.showTableData = []
					this.firstFlag = false
				}
			},
			immediate: true
		}
	},
	methods: {
		clear () {
			this.name = ''
			this.tableReload()
		},
		tableReload () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIVA}/selectShopList`
			}).then(res => {
				res.forEach(item => {
					item.checkFlag = false
				})
				this.tableData = this.$fxUtils.deepClone(res)
				const arr = this.checkArr.map(item => {
					return item.id
				})
				this.tableData.forEach(item => {
					item.checkFlag = arr.indexOf(item.id) !== -1
				})
				this.showTableData = this.tableData.filter(item => {
					return item.name.indexOf(this.name) > -1
				})
			})
		},
		changeCheckArr () {
			const arr = this.checkArr.map(item => {
				return item.id
			})
			this.tableData.forEach(item => {
				item.checkFlag = arr.indexOf(item.id) !== -1
			})
			this.showTableData = this.tableData.filter(item => {
				return item.name.indexOf(this.name) > -1
			})
			this.$nextTick(() => {
				this.$refs.table.doLayout()
			})
		},
		selectedChange (row) {
			const checkIndex = this.checkArr.findIndex(item => {
				return item.id === row.id
			})
			this.checkArr.splice(checkIndex, 1)
			this.changeCheckArr()
		},
		selectChange (row) {
			if (row.checkFlag) {
				this.checkArr.push(row)
			} else {
				const checkIndex = this.checkArr.findIndex(item => {
					return item.id === row.id
				})
				this.checkArr.splice(checkIndex, 1)
			}
		},
		cancelClick () {
			this.$emit('cancel', false)
		},
		saveClick () {
			this.$emit('saveClick', this.checkArr)
		}
	}
}
</script>
<style lang="stylus" scoped>

.binding-body{
    display: flex;
    // width :660px;
	flex-direction: column;
    overflow-y :auto;
	.search-box{
		margin-bottom :10px;
		width:100%;
		height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		.input-box-btn{
			width :80px;
		}
		.input-box{
			margin-left :10px;
			width :265px;
			margin-bottom:10px
			.name-input {
				width: 180px;
				margin-right: 10px;
			}
			.select-box{
				width:180px;
				margin-right:10px;
			}
		}
	}
	.table-wrap {
		display: flex;
		justify-content: space-between;
		margin-top: 10px;
	}
    .table-box{
		width: calc(50% - 10px)
        height: 350px;
    }
    border-radius :0px 0px 10px 10px;
    .btn-box{
        width :90%;
        padding :10px;
        text-align :left
    }
    .binding-foot{
        height :40px;
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: center
        width :100%
        .btn{
            width :35%;
        }
    }
}

</style>
<style lang="stylus">
.binding-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
